<template>
  <div :class="['app-container', $style.wrap]">
    <global-header
      :title="title"
      :showBack="showBack"
      :showMore="showMore"
      :background="headerStyle.bg"
      :mode="headerStyle.mode"
    />
    <router-view :class="$style.content" />
  </div>
</template>

<script>
import GlobalHeader from "@/components/GlobalHeader";
export default {
  name: "BasicLayout",
  components: { GlobalHeader },
  data() {
    return {
      showMore: true,
      showBack: true
    };
  },
  computed: {
    isHasRouter() {
      const titleList = ["登录", "注册", "手机注册"];
      return titleList.includes(this.$route.meta.title);
    },
    title() {
      return this.isHasRouter ? "" : this.$route.meta.title;
    },
    headerStyle() {
      const headerStyle = {
        bg: this.isHasRouter ? "#fff" : "#48d5af",
        mode: this.isHasRouter ? "dark" : "light"
      };
      return headerStyle;
    }
  },
  watch: {
    "$route.path": {
      handler: function(val) {
        const hiddenBackList = [
          "/invoiceRules",
          "/invoiceQuery",
          "/invoiceList"
        ];
        if (hiddenBackList.includes(val)) {
          this.showBack = false;
        } else {
          this.showBack = true;
        }
        if (val.indexOf("invoice") != -1) {
          this.showMore = false;
        } else {
          this.showMore = true;
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style module lang="less">
.content {
  padding-top: @global-header-height;
}
</style>
